<template>
	<div class="standard-button noselect" :class="classes">
		<template v-if="loading === false">{{text}}</template>
		<plain-spinner v-else />
	</div>
</template>

<script>
	import PlainSpinner from "@vue/components/loaders/PlainSpinner";
	export default {
		name: "StandardButton",
		components: {PlainSpinner},
		computed: {
			classes(){
				return [
					this.large === true ? 'large' : '',
					typeof this.color !== 'undefined' ? 'color-'+this.color : 'color-blue',
					this.disabled === true ? 'disabled' : ''
				]
			}
		},
		props: {
			text: {
				type: String,
				required: true
			},
			large: {
				type: Boolean,
				default: false
			},
			color: String,
			disabled: {
				type: Boolean,
				default: false
			},
			loading: {
				type: Boolean,
				default: false
			}
		}
	};
</script>

<style lang="scss" scoped>
	.standard-button{
		height: 40px;
		line-height: 40px;
		padding: 0 20px;
		text-align: center;
		font-weight: 700;
		font-size: 14px;
		border-radius: 5px;
		display: inline-block;
		cursor: pointer;
		transition: background-color 200ms ease-in-out;
		&.color-blue{
			background-color: #368bce;
			color:white;
			&:hover{
				background-color: #34a1e2;
			}
		}
		&.color-orange{
			background-color: #f39d38;
			color:white;
			&:hover{
				background-color: #ffb546;
			}
		}
		&.color-grey{
			background-color: #cccccc;
			color: #6f6f6f;
			&:hover{
				background-color: #e0e0e0;
			}
		}
		&.disabled{
			background-color: #cccccc;
			color: #6f6f6f;
			cursor: not-allowed;
			&:hover{
				background-color: #cccccc;
			}
		}
		&.large{
			height: 60px;
			line-height: 60px;
			padding: 0 60px;
		}
		.spinner-wrapper{
			margin-top: 4px;
		}
	}
</style>
